import React from 'react';
import HeartLesson from '../../components/learning/HeartLesson';

const HeartLessonPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Lesson Header */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Understanding the Human Heart</h1>
          <div className="flex flex-wrap gap-4 text-sm text-gray-600">
            <div>Grade: 4</div>
            <div>Term: 1</div>
            <div>Subject: Science</div>
            <div>Strand: Human Body</div>
            <div>Sub-strand: The Heart</div>
          </div>
          <p className="mt-4 text-gray-700">
            A comprehensive journey through the human heart and its functions.
          </p>
        </div>

        {/* Interactive Lesson Content */}
        <div className="bg-white rounded-lg shadow-md">
          <HeartLesson />
        </div>
      </div>
    </div>
  );
};

export default HeartLessonPage; 